module.exports = "<!-- main app container -->\r\n<div class=\"wrapper\">\r\n    <section class=\"top-line\"></section>\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<app-footer></app-footer>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main